<script>
    import SFS2X, { SFSObject, SFSArray } from "sfs2x-api";
    import { onMount } from 'svelte';
    import { getSFS, USER_NAME } from '../controllers/SFSController';

    export const TYPE_GLOBAL = "global";
    export const TYPE_LOBBY = "lobby";
    export const TYPE_TABLE = "table";

    export let type;

    let sfs;
    let sendButton;
    let txtMessage;
    let chatArea;

    //console.log("chat: " + type);

    onMount(() => {
        return destroy;
    });

    export function registerEvents()
    {
        sfs = getSFS();
        sfs.addEventListener(SFS2X.SFSEvent.PUBLIC_MESSAGE, onPublicMessage, this);
    }

    function destroy()
    {
        if (sfs)
        {
            sfs.removeEventListener(SFS2X.SFSEvent.PUBLIC_MESSAGE, onPublicMessage, this);
            sfs = null;
        }
    }

    function onPublicMessage(event)
    {
        const sender = event.sender.getVariable(USER_NAME).value;
        const msg = event.message;
        chatArea.value += (event.sender.isSpectator ? "(Spectator) " : "") + sender + ": " + msg + "\n";
        chatArea.scrollTop = chatArea.scrollHeight;
    }

    export function logEvent(event)
    {
        console.log(event);
        let date = new Date();
        let time = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        chatArea.value += "(" + time + ") " + event + "\n";
        chatArea.scrollTop = chatArea.scrollHeight;
    }
    
    function onSendChat()
    {
        let msg = txtMessage.value;
        txtMessage.value = "";
        
        if (msg && sfs && sfs.lastJoinedRoom)
            sfs.send(new SFS2X.PublicMessageRequest(msg, null, sfs.lastJoinedRoom));
    }

    const onKeyPress = e => {
        if (e.charCode === 13) onSendChat();
    };
</script>


<div class="vbox">
    {#if type == TYPE_GLOBAL}
        <ion-tile>Global Chat</ion-tile>
    {:else if type == TYPE_LOBBY}
        <ion-tile>Lobby Chat</ion-tile>
    {:else if type == TYPE_TABLE}
        <ion-tile>Table Chat</ion-tile>
    {/if}
    <textarea bind:this={chatArea} readonly />
    <div class="hbox">
        <input bind:this={txtMessage} type="text" on:keypress={onKeyPress}/>
        <ion-button bind:this={sendButton} on:click={onSendChat}>Send</ion-button>    
    </div>
</div>

<style>
    textarea {
        min-height: 140px;
    }

    input {
        width: 100%;
    }
   
</style>